
import {Dropdown, Space, Button, } from "antd";
import { DownloadOutlined } from '@ant-design/icons';
import logo from "../logo.png";

function MiniBitCompressor(args) {

const items = [
  {
    key: 'windows',
    label: <a href="https://api.minibit.zenofy.tr/win_release.zip" target="_blank" rel="noopener noreferrer">
        Windows Sürümü
      </a>,
  },
  {
    key: 'mac',
    label: <a href="https://api.minibit.zenofy.tr/mac_release.zip" target="_blank" rel="noopener noreferrer">
        Mac Sürümü
      </a>,
  },
];
    return (
    <div style={{backgroundColor:"#17181b",width :"100vw",height:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
        <a href="/" className="logo" style={{width:"15rem",marginBottom:"4rem"}}><img src={logo} alt="logo" style={{height:"100%",width:"100%"}}/></a>
        <Dropdown
          menu={{
            items,
            defaultSelectedKeys: ['3'],
          }} trigger={["click"]}
        >
          <Button type='primary' size='large'>
            <Space>
              Hemen İndir
              <DownloadOutlined />
            </Space>
          </Button>
        </Dropdown>
    </div>
    )
} 

export default MiniBitCompressor;